import init from "@kiwicom/nitro/lib/services/session/init"
import { sessionDefault, Session } from "@kiwicom/nitro/lib/records/Session"

const getSession = (): Session => {
  // Taken from 'cuckoo.js'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (typeof window !== "undefined" && (window as any).SP_GLOBALS) {
    return init()
  }
  return sessionDefault // server fallback
}

const session = getSession()

export default session
